import React from "react";
import { PropTypes } from "prop-types";
import * as ProductFamilies from "../../../constants/productFamilies";

const ProductInfo = (props) => {
  const hasTitle = props.title !== undefined && props.title !== "";
  const IsRWA03 = props.isrwa03?true:false;
  const IsRWA04 = props.isrwa04?true:false;
 const isHPI=props.PartnerURLVal&& props.PartnerURLVal.toUpperCase()==="HPI";
 const isInsight=props.PartnerURLVal&& props.PartnerURLVal.toUpperCase()==="INSIGHT";
 const isEscape=props.PartnerURLVal&& props.PartnerURLVal.toUpperCase()==="ESCAPE";
 const isWWT=props.PartnerURLVal&& props.PartnerURLVal.toUpperCase()==="WWT";
 const isDELL=props.PartnerURLVal&& props.PartnerURLVal.toUpperCase()==="DELL";
 const EDUOmniverseTitle="Free Enterprise Omniverse for Higher Education and Research";
 const VgpuTitle="Start your 90-day vGPU trial";
 const NMVATitle="Start your 90-day NMVA trial";
 const SpectrumXTitle="Start your 90-day Spectrum-X trial";
 const NVaiEnterTitle="Start your 90-day NVIDIA AI Enterprise trial";
 const NVaiDGXSparkTitle="Start your 90-day NVIDIA AI Enterprise for DGX Spark";
 const bcmTitle="REGISTER TO REQUEST YOUR FREE LICENSE";
 const NetQSaasTitle="Start your 365-day NetQ SaaS trial";
 const NetQTitle="Start your 90-day NetQ trial";
 const UFMTitle="Start your 60-day Unified Fabric Manager (UFM®) Evaluation Registration.";
 const UFMTitle2="Unified Fabric Manager (UFM®) is a powerful platform for managing scale-out computing environments. UFM enables data center operators to efficiently monitor and operate the entire fabric, boost application performance, and maximize fabric resource utilization.";
 const UFMTitle1="Get started today with a 60-day free evaluation of Unified Fabric Manager (UFM®) and see for yourself UFM's power to effectively provision, monitor, and operate your modern InfiniBand fabric.";
 const OmniverseTitle="Start your 90-day Omniverse Enterprise trial";
 let title="";
 const PartnerOmniverseTitle="Start your 90-day Partner Omniverse Enterprise trial";
 const NvaieTitle="Start your 90-day AI Enterprise trial";
 if (isHPI) {
  title ="Hello HP customer, welcome to the Omniverse Enterprise 90 day trial."
} else if(isInsight) {
  title ="Hello Insight customer, welcome to the Omniverse Enterprise 90 day trial."
}
else if(isEscape)
{
  title ="Hello Escape Technology customer, welcome to the Omniverse Enterprise 90 day trial."
}
else if(isWWT)
{
  title ="Hello WWT customer, welcome to the Omniverse Enterprise 90 day trial."
}
else{
title="Start your 90-day Partner Omniverse Enterprise trial";
}

  if (IsRWA03 &&
   props.productfamily.toUpperCase()===ProductFamilies.vgpu
    ) {
     
    return (
      <div className={"infoBlock"}>
        <div className={"infoBlockEval"}>
          { <h3>{VgpuTitle}</h3>}
          <h4>
            <b>IMPORTANT TIPS </b>
          </h4>
          <ul>
            <li>Please register with your corporate email address.</li>
            <li>
              Personal email addresses or extensions will not be approved.
            </li>
            <li>NVIDIA virtual GPU solutions are designed to run on NVIDIA® GPUs. Please ensure you have the following before downloading the NVIDIA virtual GPU software evaluation edition:
              
               </li>
               <ul>
                    <li>NVIDIA Virtual GPU Certified Servers.<a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/data-center/resources/vgpu-certified-servers/'
              >
                {" "}
                See a complete list of certified systems.{" "}
              </a>{" "}</li>
              <li>
                <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/data-center/graphics-cards-for-virtualization/'
              >
                {" "}
                Supported NVIDIA GPUs:{" "}
              </a>{" "} NVIDIA A10, A16, A30, A40, A100, T4, RTX 8000, RTX 6000, V100S, V100, P100, P40, P6, P4, M60, M10</li>
              <li>
            Virtualization Software from VMware, Citrix, Red Hat, and Nutanix.
            </li>
               </ul>
           
            <li>
              {" "}
              If you don’t have NVIDIA GPUs, but would like to purchase, please <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/contact/sales/'
              >
                {" "}
                contact us.{" "}
              </a>
            </li>
            
          </ul>
          
        </div>
      </div>
    );
  }
  else if((IsRWA03||IsRWA04) && props.productfamily.toUpperCase()===ProductFamilies.Partneromniverse) {
    return (
      <div className={"infoBlock"}>
        
        <div className={"infoBlockEval"}>

        { <h3>{title}</h3>}
        <h4>
            <b>IMPORTANT TIPS </b>
          </h4>
          <ul>
            <li>Please register with your corporate email address.</li>
            <li>
              Personal email addresses or extensions will not be approved.
            </li>
            
            <li>
              Please ensure that the person who is registering for the
              evaluation licenses is the person who will be managing those
              licenses.
            </li>
           
            
  
  <li>Please ensure the following requirements are met:
              <ul>
                <li>
                Minimum GPU requirements are RTX-enabled GPUs with 6GB VRAM
                </li>
                <li>
                Recommended GPU requirements are RTX-enabled GPUs with 8GB VRAM
                </li>
              </ul>
              </li>
              
        
              <li>
              For information about supported hardware and software, refer to the system requirements per app or platform 
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://docs.omniverse.nvidia.com/platform/latest/common/technical-requirements.html'
              >
                {" "}
                here{" "}
              </a>{" "}
                </li>
         
            <li>
              {" "}
              If already registered, click <a href={props.idmlogin}>here</a>
            </li>
            <li>
              If you need assistance with registration or are seeking an
              exception, please review{" "}
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/nvidia-omniverse-partner-faq/'
              >
                {" "}
                FAQ{" "}
              </a>{" "}
              .
            </li>
          </ul>
        </div>
      </div>
    );
  }
  else if(IsRWA03 && props.productfamily.toUpperCase()===ProductFamilies.omniverse&& props.licensetype.toUpperCase()===ProductFamilies.LicenseTypeEDU) {
    return (
      <div className={"infoBlock"}>
        
        <div className={"infoBlockEval"}>
         
         { <h3>{EDUOmniverseTitle}</h3>} 
        <h4>
            <b>IMPORTANT TIPS </b>
          </h4>
          <ul>
            <li>Each University will need a single contact to manage licenses.</li>
            <li>
            Please ensure that the person who is registering for the evaluation licenses is the person who will be managing those licenses.
            </li>
            
            <li>
            Please register with your university email address. 
            </li>
            <li>
            Personal email addresses or extensions will not be approved. 
            </li>
      
            <li>Please ensure the following requirements are met:
              <ul>
                <li>
                Minimum GPU requirements are RTX-enabled GPUs with 6GB VRAM
                </li>
                <li>
                Recommended GPU requirements are RTX-enabled GPUs with 8GB VRAM
                </li>
              </ul>
              </li>
  
              <li>
              For information about supported hardware and software, refer to the system requirements per app or platform 
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://docs.omniverse.nvidia.com/platform/latest/common/technical-requirements.html'
              >
                {" "}
                here{" "}
              </a>{" "}
                </li>
  


            <li>
              {" "}
              If already registered, click <a href={props.idmlogin}>here</a>
            </li>
            <li>
              If you need assistance with registration or are seeking an
              exception, please review{" "}
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/omniverse/enterprise/free-trial/#faqs'
              >
                {" "}
                FAQ{" "}
              </a>{" "}
              .
            </li>
          </ul>
        </div>
      </div>
    );
  }
  else if((IsRWA03 || IsRWA04) &&props.productfamily.toUpperCase()===ProductFamilies.omniverse) {
    return (
      <div className={"infoBlock"}>
        
        <div className={"infoBlockEval"}>
         
         { <h3>{OmniverseTitle}</h3>} 
        <h4>
            <b>IMPORTANT TIPS </b>
          </h4>
          <ul>
            <li>Please register with your corporate email address.</li>
            <li>
              Personal email addresses or extensions will not be approved.
            </li>
            
            <li>
              Please ensure that the person who is registering for the
              evaluation licenses is the person who will be managing those
              licenses.
            </li>
            {isDELL && 
                <li>
                Recommended GPU requirements are RTX-enabled GPUs with 8GB VRAM.
                </li>
               
            }
            {!isDELL && 
            <li>Please ensure the following requirements are met:
              <ul>
                <li>
                Minimum GPU requirements are RTX-enabled GPUs with 6GB VRAM
                </li>
                <li>
                Recommended GPU requirements are RTX-enabled GPUs with 8GB VRAM
                </li>
              </ul>
              </li>
  }
              <li>
              For information about supported hardware and software, refer to the system requirements per app or platform 
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://docs.omniverse.nvidia.com/platform/latest/common/technical-requirements.html'
              >
                {" "}
                here{" "}
              </a>{" "}
                </li>
  


            <li>
              {" "}
              If already registered, click <a href={props.idmlogin}>here</a>
            </li>
            <li>
              If you need assistance with registration or are seeking an
              exception, please review{" "}
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/omniverse/enterprise/free-trial/#faqs'
              >
                {" "}
                FAQ{" "}
              </a>{" "}
              .
            </li>
          </ul>
        </div>
      </div>
    );
  }
  else if(IsRWA03 && props.productfamily.toUpperCase()===ProductFamilies.nvaie) {
    return (
      <div className={"infoBlock"}>
        <div className={"infoBlockEval"}>
        { <h3>{NvaieTitle}</h3>}
        <h4>
            <b>IMPORTANT TIPS </b>
          </h4>
          <ul>
            <li>Please register with your corporate email address.</li>
            <li>
              Personal email addresses or extensions will not be approved.
            </li>
            
            <li>
              Please ensure that the person who is registering for the
              evaluation licenses is the person who will be managing those
              licenses.
            </li>
            <li>
              {" "}
              If already registered, click <a href={props.idmlogin}>here</a>
            </li>
            <li>
              If you need assistance with registration or are seeking an
              exception, please review{" "}
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/nvidia-enterprise-account-faq/'
              >
                {" "}
                FAQ{" "}
              </a>{" "}
              
            </li>
          </ul>
          </div>
      </div>
    );
  }
  else if(IsRWA03 && props.productfamily.toUpperCase()===ProductFamilies.NETQSAAS) {
    return (
      <div className={"infoBlock"}>
        <div className={"infoBlockEval"}>
        { <h3>{NetQSaasTitle}</h3>}
        <h4>
            <b>IMPORTANT TIPS </b>
          </h4>
          <ul>
            <li>Please register with your corporate email address.</li>
            <li>
              Personal email addresses or extensions will not be approved.
            </li>
            
            <li>
            NVIDIA NetQ SaaS is a network monitoring and troubleshooting solution for NVIDIA® Ethernet Switches. Please ensure you have the following before downloading the NVIDIA NetQ software for evaluation:  
            <ul>
                <li>
                NVIDIA {" "}
              <a
                rel='noopener noreferrer'
                target='_blank'
                href=' https://www.nvidia.com/en-us/networking/ethernet-switching/'
              >
                {" "}
                Spectrum Ethernet Switches
              </a>{" "} {" "} running Cumulus Linux or SONiC.
                </li>
                <li>
                VMware ESXi or KVM server to deploy NetQ software.
               
                </li>
            </ul>
            </li>
           
            <li>
            If you don’t have NVIDIA Spectrum Ethernet Switches, but would like to purchase, please{" "}
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/networking/buy/'
              >
                {" "}
                contact us.{" "}
              </a>{" "}
              
            </li>
          </ul>
          </div>
      </div>
    );
  }
  else if(IsRWA03 && props.productfamily.toUpperCase()===ProductFamilies.NETQ) {
    return (
      <div className={"infoBlock"}>
        <div className={"infoBlockEval"}>
        { <h3>{NetQTitle}</h3>}
        <h4>
            <b>IMPORTANT TIPS </b>
          </h4>
          <ul>
            <li>Please register with your corporate email address.</li>
            <li>
              Personal email addresses or extensions will not be approved.
            </li>
            
            <li>
            NVIDIA NetQ is a network monitoring and troubleshooting solution for NVIDIA® Ethernet Switches. Please ensure you have the following before downloading the NVIDIA NetQ software for evaluation:  
            <ul>
                <li>
                NVIDIA {" "}
              <a
                rel='noopener noreferrer'
                target='_blank'
                href=' https://www.nvidia.com/en-us/networking/ethernet-switching/'
              >
                {" "}
                Spectrum Ethernet Switches
              </a>{" "} {" "} running Cumulus Linux or SONiC.
                </li>
                <li>
                VMware ESXi or KVM server to deploy NetQ software.
               
                </li>
            </ul>
            </li>
           
            <li>
            If you don’t have NVIDIA Spectrum Ethernet Switches, but would like to purchase, please{" "}
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/networking/buy/'
              >
                {" "}
                contact us.{" "}
              </a>{" "}
              
            </li>
          </ul>
          </div>
      </div>
    );
  }
  else if(IsRWA03 && props.productfamily.toUpperCase()===ProductFamilies.UFM) {
    return (
      <div className={"infoBlock"}>
        <div className={"infoBlockEval"}>
        { <p>
          {/* {UFMTitle}
        <br></br>
        {UFMTitle2}
        <br></br> */}
        {UFMTitle1}
        </p>}
        <h4>
            <b>IMPORTANT TIPS </b>
          </h4>
          <ul>
            <li>Please register with your corporate email address.</li>
            <li>
              Personal email addresses or extensions will not be approved.
            </li>
            
            
            
          
                <li>
                If you would like to purchase UFM, please{" "}
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/contact/sales/'
              >
                {" "}
                contact us.{" "}
              </a>{" "}
                </li>
              
          
            
           
            <li>
            If you don’t have NVIDIA InfiniBand clusters, but would like to purchase, please {" "}
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/networking/buy/'
              >
                {" "}
                contact us.{" "}
              </a>{" "}
              
            </li>
          </ul>
          </div>
      </div>
    );
  }
  else if(IsRWA03 && props.productfamily.toUpperCase()===ProductFamilies.SpectrumX) {
   
    return (
      <div className={"infoBlock"}>
        
        <div className={"infoBlockEval"}>
         
         { <h3>{SpectrumXTitle}</h3>} 
        <h4>
            <b>IMPORTANT TIPS </b>
          </h4>
          <ul>
            <li>Please register with your corporate email address.</li>
            <li>
              Personal email addresses or extensions will not be approved.
            </li>
            
            <li>
            NVIDIA Spectrum-X is designed to run on networks powered by NVIDIA Spectrum-4 Ethernet Switches and BlueField-3 DPUs.
            Please ensure you have the following before downloading the Spectrum-X software evaluation edition:
            <li>NVIDIA Spectrum SN5000 series Ethernet Switches</li>
            <li>NVIDIA BlueField-3 DPUs</li>
            <li>NVIDIA Support for Cumulus Linux NOS or ONIE</li>
            </li>
            <li>
            Without Cumulus or ONIE support, you will be unable to access the NVIDIA Enterprise Support Portal for your Spectrum-X evaluation. 
            If you are unsure whether your organization has registered your email for Cumulus or ONIE support, 
            please contact your support administrator to be added to the NVIDIA Enterprise Support Portal. 
            </li>
                
               
            
         
              <li>
              If you don’t have NVIDIA networking, but would like to purchase,
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/contact/sales/'
              >
                {" "}
                contact us.{" "}
              </a>{" "}
                </li>
  


          </ul>
        </div>
      </div>
    );
  }
  else if(IsRWA04 && props.productfamily.toUpperCase()===ProductFamilies.NvaiEnter) {
   
   
    return (
      <div className={"infoBlock"}>
        
        <div className={"infoBlockEval"}>
         
         { <h3>{NVaiEnterTitle}</h3>} 
        <h4>
            <b>IMPORTANT TIPS </b>
          </h4>
          <ul>
            <li>Please register with your corporate email address.</li>
            <li>
              Personal email addresses or extensions will not be approved.
            </li>
            
         
               
            
         
              <li>
              To participate in the evaluation, compatible infrastructure is required.  Please refer to the  {" "}
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://docs.nvidia.com/ai-enterprise/latest/product-support-matrix/'
              >
                {" "}
                product support matrix {" "}
              </a>{" "}for certified configurations.
                </li>
                <li>
                If you don’t have NVIDIA Compatible Systems, but would like to purchase, please  {" "}
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/contact/sales/'
              >
                {" "}  
                contact us.{" "}
              </a>{" "}
                </li>


          </ul>
        </div>
      </div>
    );
   
   
  }
  else if(IsRWA04 && props.productfamily.toUpperCase()===ProductFamilies.NVAIESPARK) {
   
   
    return (
      <div className={"infoBlock"}>
        
        <div className={"infoBlockEval"}>
         
         { <h3>{NVaiDGXSparkTitle}</h3>} 
        <h4>
            <b>IMPORTANT TIPS </b>
          </h4>
          <ul>
            <li>Please register with your corporate email address.</li>
            <li>
              Personal email addresses or extensions will not be approved.
            </li>
            
         
               
            
         
              <li>
              To participate in the evaluation you must have   {" "}
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/products/workstations/dgx-spark/'
              >
                {" "}
               NVIDIA DGX Spark {" "}
              </a>{" "}
                </li>
                <li>
                If you don’t have NVIDIA DGX Spark, but would like to purchase, please  {" "}
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://marketplace.nvidia.com/en-us/enterprise/personal-ai-supercomputers/dgx-spark/'
              >
                {" "}  
                Buy Now{" "}
              </a>{" "}
                </li>


          </ul>
        </div>
      </div>
    );
   
   
  }
  else if(IsRWA03 && props.productfamily.toUpperCase()===ProductFamilies.BCM) {
   
   
    return (
      <div className={"infoBlock"}>
        
        <div className={"infoBlockEval"}>
         
         { <h3>{bcmTitle}</h3>} 
         <p>For AI and HPC clusters,  <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/data-center/base-command/manager/'
              >
                {" "}
                Base Command Manager
              </a>  is available for free for up to eight accelerators per system—NVIDIA GPU-accelerated or other—in any cluster size.
           This free-to-use license is subject to change and doesn't include support. </p>
        <h4>
            <b>IMPORTANT TIPS </b>
          </h4>
          <ul>
            <li>Please register with your corporate email address.</li>
            <li>
              Personal email addresses or extensions will not be approved.
            </li>                   
              <li>
              This free Base Command Manager download license is only available to organizations for their own use. It is not available to organizations building products or services with Base Command Manager for resale.
                </li>
            </ul>
            <h4>WAYS TO GET ENTERPRISE SUPPORT </h4>
            <ul>
              <li>
              NVIDIA Enterprise Support can be purchased for the Base Command Manager free license.  To purchase support, contact your authorized   <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/about-nvidia/partners/partner-locator/'
              >
                {" "}
                NVIDIA Enterprise Partner. 
              </a> 
              {" "}  This won't include support for GPU Operator, Network Operator, and vGPU.
              </li>
              <li>
              Support for Base Command Manager, GPU Operator, Network Operator, and vGPU is available with    <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/data-center/products/ai-enterprise/'
              >
                {" "}
                NVIDIA AI Enterprise
              </a> 
              {" "}   which also includes a catalog of AI and data science microservices, libraries, and toolkits.
              </li>
              <li>
              With  <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/data-center/mission-control/'
              >
                {" "}
                NVIDIA Mission Control
              </a> 
              {" "}you can run models and automate essential operations. In addition to including support for Base Command Manager and other capabilities, Mission Control simplifies AI factory operations. 

              </li>
            </ul>
        </div>
      </div>
    );
   
   
  }
  if (IsRWA03 &&
    props.productfamily.toUpperCase()===ProductFamilies.NMVA
     ) {
      
     return (
       <div className={"infoBlock"}>
         <div className={"infoBlockEval"}>
           { <h3>{NMVATitle}</h3>}
           <h4>
             <b>IMPORTANT TIPS </b>
           </h4>
           <ul>
             <li>Please register with your corporate email address.</li>
             <li>
               Personal email addresses or extensions will not be approved.
             </li>
             <li>NVIDIA virtual GPU solutions are designed to run on NVIDIA® GPUs. Please ensure you have the following before downloading the NVIDIA virtual GPU software evaluation edition:
               
                </li>
                <ul>
                     <li>NVIDIA Virtual GPU Certified Servers.<a
                 rel='noopener noreferrer'
                 target='_blank'
                 href='https://www.nvidia.com/en-us/data-center/resources/vgpu-certified-servers/'
               >
                 {" "}
                 See a complete list of certified systems.{" "}
               </a>{" "}</li>
               <li>
                 <a
                 rel='noopener noreferrer'
                 target='_blank'
                 href='https://www.nvidia.com/en-us/data-center/graphics-cards-for-virtualization/'
               >
                 {" "}
                 Supported NVIDIA GPUs:{" "}
               </a>{" "} NVIDIA A10, A16, A30, A40, A100, T4, RTX 8000, RTX 6000, V100S, V100, P100, P40, P6, P4, M60, M10</li>
               <li>
             Virtualization Software from VMware, Citrix, Red Hat, and Nutanix.
             </li>
                </ul>
            
             <li>
               {" "}
               If you don’t have NVIDIA GPUs, but would like to purchase, please <a
                 rel='noopener noreferrer'
                 target='_blank'
                 href='https://www.nvidia.com/en-us/contact/sales/'
               >
                 {" "}
                 contact us.{" "}
               </a>
             </li>
             
           </ul>
           
         </div>
       </div>
     );
   }
  else if(IsRWA03 ) {
    return (
      <div className={"infoBlock"}>
        <div className={"infoBlockEval"}>
          { <h3>{VgpuTitle}</h3>}
          <h4>
            <b>IMPORTANT TIPS </b>
          </h4>
          <ul>
            <li>Please register with your corporate email address.</li>
            <li>
              Personal email addresses or extensions will not be approved.
            </li>
            <li>NVIDIA virtual GPU solutions are designed to run on NVIDIA® GPUs. Please ensure you have the following before downloading the NVIDIA virtual GPU software evaluation edition:
              
               </li>
               <ul>
                    <li>NVIDIA Virtual GPU Certified Servers.<a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/data-center/resources/vgpu-certified-servers/'
              >
                {" "}
                See a complete list of certified systems.{" "}
              </a>{" "}</li>
              <li>
                <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/data-center/graphics-cards-for-virtualization/'
              >
                {" "}
                Supported NVIDIA GPUs:{" "}
              </a>{" "} NVIDIA A10, A16, A30, A40, A100, T4, RTX 8000, RTX 6000, V100S, V100, P100, P40, P6, P4, M60, M10</li>
              <li>
            Virtualization Software from VMware, Citrix, Red Hat, and Nutanix.
            </li>
               </ul>
           
            <li>
              {" "}
              If you don’t have NVIDIA GPUs, but would like to purchase, please <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/contact/sales/'
              >
                {" "}
                contact us.{" "}
              </a>
            </li>
            
          </ul>
          
        </div>
      </div>
    );
  }
  
  
};


ProductInfo.propTypes = {
  PartnerURLVal: PropTypes.string,
  title: PropTypes.string,
  isrwa03: PropTypes.number.isRequired,
  isrwa04: PropTypes.number.isRequired,
   productfamily: PropTypes.string.isRequired,
   link: PropTypes.string.isRequired,
   linktext: PropTypes.string.isRequired,
   idmlogin: PropTypes.string.isRequired,
};

export default ProductInfo;
